import script from "./ClientCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientCard.vue?vue&type=script&setup=true&lang=ts"

import "./ClientCard.vue?vue&type=style&index=0&id=39c4f8c5&lang=scss"

const __exports__ = script;

export default __exports__